import * as React from 'react';

export type FavoriteTeaserCellPropsType = {
	children: React.ReactNode;
};

export class FavoriteTeaserCell extends React.Component<FavoriteTeaserCellPropsType> {
	public static displayName = 'FavoriteTeaserCell';

	public render() {
		return (
			<div className="o-profile__teaser">
				<div className="col-xs-12 col-sm-12 col-md-4">{this.props.children}</div>
			</div>
		);
	}
}

export default FavoriteTeaserCell;
